"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable jsx-a11y/click-events-have-key-events */
const AutocompleteHolder = _styledComponents.default.div.withConfig({
  displayName: "Autocomplete__AutocompleteHolder",
  componentId: "design-system__kaw7t8-0"
})(["ul{margin:0;padding:0;list-style:none;border:1px solid ", ";border-top:0;border-radius:0 0 ", " ", ";overflow:hidden;}li{display:block;}button{display:block;padding:0;border:0;width:100%;text-align:left;font-size:", ";padding:", ";color:", ";font-family:", ";line-height:100%;:hover,&.suggestion-active{color:", ";}}.no{display:block;font-size:", ";color:", ";font-family:", ";font-style:italic;padding:", ";line-height:100%;}&.show-suggestion{.input-autocomplete{border-radius:", " ", " 0 0;}}"], _BaseTheme.default.colors.gray, _BaseTheme.default.radius.regular, _BaseTheme.default.radius.regular, _BaseTheme.default.type.size.normal, _BaseTheme.default.distance.small, _BaseTheme.default.colors.textgray, _BaseTheme.default.type.family.content, _BaseTheme.default.colors.gray, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.textgray, _BaseTheme.default.type.family.content, _BaseTheme.default.distance.small, _BaseTheme.default.radius.regular, _BaseTheme.default.radius.regular);

const Autocomplete = _ref => {
  let {
    suggestions,
    onChange,
    name,
    id,
    placeholder
  } = _ref;
  const [activeSuggestion, setActiveSuggestion] = (0, _react.useState)(0);
  const [filteredSuggestions, setFilteredSuggestions] = (0, _react.useState)([]);
  const [showSuggestions, setShowSuggestions] = (0, _react.useState)(false);
  const [userInput, setUserInput] = (0, _react.useState)('');

  const eventOnChange = e => {
    const {
      value
    } = e.target;
    setFilteredSuggestions(suggestions.filter(suggestion => suggestion.toLowerCase().indexOf(value.toLowerCase()) > -1));
    setActiveSuggestion(0);
    setShowSuggestions(true);
    setUserInput(value);
    onChange(value);
  };

  const onKeyDown = e => {
    const {
      keyCode
    } = e;

    if (keyCode === 13) {
      setActiveSuggestion(0);
      setShowSuggestions(false);
      setUserInput(filteredSuggestions[activeSuggestion]);
      onChange(filteredSuggestions[activeSuggestion]);
    } else if (keyCode === 38) {
      if (activeSuggestion === 0) return;
      setActiveSuggestion(activeSuggestion - 1);
    } else if (keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) return;
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const onClick = e => {
    setActiveSuggestion(0);
    setFilteredSuggestions([]);
    setShowSuggestions(false);
    setUserInput(e.target.innerText);
    onChange(e.target.innerText);
  };

  return /*#__PURE__*/_react.default.createElement(AutocompleteHolder, {
    className: "".concat(showSuggestions && userInput ? 'show-suggestion' : '')
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    name: name,
    id: id,
    placeholder: placeholder,
    endIcon: "search",
    onChange: eventOnChange,
    onKeyDown: onKeyDown,
    value: userInput,
    className: "input-autocomplete",
    autocomplete: "off"
  }), showSuggestions && userInput && /*#__PURE__*/_react.default.createElement("ul", null, filteredSuggestions.length ? filteredSuggestions.map((suggestion, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: suggestion
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "".concat(index === activeSuggestion ? 'suggestion-active' : ''),
    onClick: onClick
  }, suggestion))) : /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "no"
  }, "No suggestions"))));
};

Autocomplete.propTypes = {
  suggestions: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  onChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string
};
Autocomplete.defaultProps = {
  name: undefined,
  id: undefined,
  placeholder: ''
};
var _default = Autocomplete;
exports.default = _default;